module.exports = "https://web-assets.ifttt.com/packs/media/docs/appletpage-3c4aed52.png";